<template>
  <div>
    <div class="footer">
      <van-tabbar id="navStyle" class="navItems">
        <van-tabbar-item>
          <div class="eventtab">
            <router-link to="/events" active-class="Active">
              <div style="height: 30px">
                <img class="footer_icon" />
              </div>
              <p style="color:black;">{{$t('footer.event')}}</p>
            </router-link>
          </div>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="bonustab">
            <router-link to="/bonus" active-class="Active">
              <div style="height: 30px">
                <img class="footer_icon" />
              </div>
              <p style="color:black;">{{$t('footer.bonus')}}</p>
            </router-link>
          </div>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="hometab">
            <router-link to="/index" active-class="Active">
              <div style="height: 30px">
                <img class="footer_icon" />
              </div>
              <p style="color:black;">{{$t('footer.home')}}</p>
            </router-link>
          </div>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="teamtab">
            <router-link to="/team" active-class="Active">
              <div style="height: 30px">
                <img class="footer_icon" />
              </div>
              <p style="color:black;">{{$t('footer.team')}}</p>
            </router-link>
          </div>
        </van-tabbar-item>
        <van-tabbar-item>
          <div class="profiletab">
            <router-link to="/member" active-class="Active">
              <div style="height: 30px">
                <img class="footer_icon" />
              </div>
              <p style="color:black;">{{$t('footer.profile')}}</p>
            </router-link>
          </div>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Tabbar, TabbarItem } from "vant";
Vue.use(Tabbar).use(TabbarItem);
export default {
  name: "Footer",
  data() {
    return {
      active: null,
    };
  },
  computed: {},
  methods: {
    nav() {
      let that = this;
      var url = window.location.href;

      if (url.includes("event")) {
        that.active = 0;
      } else if (url.includes("bonus")) {
        that.active = 1;
      } else if (url.includes("index")) {
        that.active = 2;
      } else if (url.includes("myTeam")) {
        that.active = 3;
      } else if (url.includes("user")) {
        that.active = 4;
      } 
    },
  },
  mounted: function () {
    this.nav();
  },
};
</script>


<style scoped>
.navItems {
  padding: 2px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  background: #f3da2f;
  text-align: center;
}

.navItems::after {
  border: unset !important;
}

.eventtab img {
  content: url("../views/images/common/Event.png");
}

.eventtab .Active img {
  content: url("../views/images/common/Event_Checked.png");
}

.bonustab img {
  content: url("../views/images/common/Bonus.png");
}

.bonustab .Active img {
  content: url("../views/images/common/Bonus_Checked.png");
}

.hometab img {
  content: url("../views/images/common/Home.png");
  height: 44px;
  position: absolute;
  top: 15px;
  transform: translate(-50%, -50%);
  width: 44px;
}

.hometab .Active img {
  content: url("../views/images/common/Home_Checked.png");
  height: 44px;
  position: absolute;
  top: 15px;
  transform: translate(-50%, -50%);
  width: 44px;
}

.teamtab img {
  content: url("../views/images/common/Team.png");
}

.teamtab .Active img {
  content: url("../views/images/common/Team_Checked.png");
}

.profiletab img {
  content: url("../views/images/common/Profile.png");
}

.profiletab .Active img {
  content: url("../views/images/common/Profile_Checked.png");
}

.footer_icon {
  height: 30px;
  width: 30px;
}

.Active p {
  color: #000000;
}

.Active img {
  height: 30px;
  width: 30px;
}

.footer:before {
  content: " ";
  position: absolute;
  width: 70px;
  height: 70px;
  display: block;
  left: 50%;
  margin-left: -34px;
  top: -16px;
  z-index: 1;
  background-color: #f3da2f;
  border: 0.5px solid #f3da2f;
  border-radius: 100%;
  box-sizing: border-box;
}

/* // .ucentertab img {
//   content: url("../views/images/common/user.png");
// }

// .ucentertab .Active img {
//   content: url("../views/images/common/user_cur.png");
// } */
</style>
<style scoped>
#navStyle .van-tabbar-item--active {
  background: transparent !important;
}
</style>

